import { JOURNAL_HISTORIES_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/journal_histories_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator(['journalHistoriesIndex']);

export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
